<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<!-- eslint-disable @angular-eslint/template/alt-text -->
<div class="spinner" *ngIf="!(ready | async)">
  <div class="spinner__content">
    <rx-icon name="icon-spinner"></rx-icon>
    <div>Please wait...</div>
  </div>
  <div class="spinner__backdrop"></div>
</div>

<!-- Discrepancy Warning -->
<div
  class="discrepancy-warning"
  *ngIf="
    hasDiscrepancies &&
    !isPreview &&
    !isRxPortal &&
    mode !== 'kiosk' &&
    !(form.status === 2 && form.shared_with_patient)
  "
>
  <div class="discrepancy-warning__icon">
    <rx-icon name="icon-warning-circle"></rx-icon>
  </div>
  <div class="discrepancy-warning__content">
    <div class="discrepancy-warning__title">Discrepancy Detected</div>
    <div class="discrepancy-warning__message">
      Highlighted fields indicate discrepancy between original form values and current client record in PatientNow.<br />
      Please review and confirm correct values.
    </div>
    <div class="discrepancy-warning__table" *ngIf="discrepancies && discrepancies.length > 0">
      <table class="discrepancy-table">
        <thead>
          <tr>
            <th>Field Name</th>
            <th>Form Value</th>
            <th>PatientNow Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let discrepancy of discrepancies">
            <td>
              {{
                discrepancy.insuranceName
                  ? discrepancy.insuranceName + (discrepancy.field !== 'Presence' ? ' - ' + discrepancy.field : '')
                  : discrepancy.field || discrepancy.category
              }}
            </td>
            <td>{{ discrepancy.saved || discrepancy.savedValue || '-' }}</td>
            <td>{{ discrepancy.current || discrepancy.currentValue || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Save Error Alert -->
<div class="save-error-alert" *ngIf="saveError">
  <div class="save-error-alert__icon">
    <rx-icon name="icon-x-circle"></rx-icon>
  </div>
  <div class="save-error-alert__content">
    <div class="save-error-alert__title">Error Saving Form</div>
    <div class="save-error-alert__message">
      {{ saveError }}
    </div>
  </div>
  <button class="save-error-alert__dismiss" type="button" (click)="saveError = null" aria-label="Dismiss error">
    <rx-icon name="icon-x"></rx-icon>
  </button>
</div>

<div
  #container
  class="flex"
  style="margin: 0 auto"
  [ngStyle]="{ width: autoScale ? '960px' : '100%', 'max-width': autoScale ? '960px' : '100%' }"
>
  <ng-container *ngIf="!form?.form_data && form?.pdf_file">
    <pdf-viewer
      [src]="form.pdf_file"
      [original-size]="false"
      [fit-to-page]="true"
      (onLoaded)="onLoaded($event)"
    ></pdf-viewer>
  </ng-container>

  <div
    #printPages
    class="flex print-container column-layout"
    *ngIf="formData"
    [ngStyle]="{ width: autoScale ? '960px' : '100%', 'max-width': autoScale ? '960px' : '100%', margin: '0 auto' }"
    [ngClass]="{ wrap: config.wrap, 'responsive-layout': !config.wrap }"
  >
    <!--  DISABLED DUE TO RXADMIN-2384: && !form?.pdf_file -->
    <div class="header-container" *ngIf="doctor && formData.properties?.showHeader?.value">
      <div class="logo" *ngIf="clinicLogo$ | async">
        <img [src]="clinicLogo$ | async" (load)="onLogoLoaded($event)" (error)="onLogoLoadError($event)" />
      </div>
      <div class="details">
        <h3 style="display: block; line-height: 55px">{{ formTemplate?.name || form?.template?.name }}</h3>
        <div style="display: block" *ngIf="client">
          {{ ((client.first_name || '') + ' ' + (client.last_name || '')).trim() }}
        </div>
        <!-- <div style="display: block;">{{ getToday() }}</div> -->
      </div>
    </div>

    <div class="section-container">
      <div class="section" *ngFor="let section of formData?.sections; let sectionIndex = index">
        <!-- [ngStyle]="{width: containerWidth + 'px', height: containerHeight + 'px'}" -->
        <div #sections class="section-list">
          <div
            class="widget-container"
            [ngClass]="{ readonly: config?.readonly }"
            [attr.data-amendment-widget]="getAmendmentWidgetId(sectionIndex, idx)"
            *ngFor="let widget of section.widgets; let idx = index; let last = last"
          >
            <app-form-element
              #widgets
              #printWidgets
              [entity]="form"
              [patient]="client"
              [patientId]="config?.patientId"
              [appointment]="appointment"
              [appointmentId]="appointmentId"
              [treatmentId]="treatmentId"
              [savedFormData]="form?.form_data"
              [isRxPortal]="isRxPortal"
              [payload]="widget"
              [branded]="formTemplate?.type === 1 || form?.template?.type === 1"
              [isPrinting]="false"
              [isPreview]="isPreview"
              [isEmrReadonly]="isEmrReadonly"
              [wrap]="wrap"
              [mode]="mode"
              (ready)="onWidgetReady($event, widget)"
              (action)="onActionEvent($event)"
              (discrepanciesDetected)="onInsuranceDiscrepanciesDetected($event)"
            ></app-form-element>
          </div>
        </div>
      </div>
      <div class="footer-container" *ngIf="formData.properties?.showFooter?.value && formData.properties?.footer">
        <div class="footer">
          {{ formData.properties.footer.value }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="ready | async">
  <div id="ALL_WIDGETS_LOADED"></div>
</ng-container>
